import { render, staticRenderFns } from "./event.vue?vue&type=template&id=49503cea&scoped=true"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"
import style0 from "./event.vue?vue&type=style&index=0&id=49503cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49503cea",
  null
  
)

export default component.exports